import { useEffect } from 'react';

const useKeyBoardListener = (keyDownHandler = () => {}) => {
  useEffect(() => {
    window.addEventListener("keydown", keyDownHandler);

    return () => {
      window.removeEventListener("keydown", keyDownHandler);
    }
  }, [keyDownHandler])
}

export default useKeyBoardListener;
